import { InspectionRequestItemStatus } from '@core/enums/inspection-request-item-status';
import { DisplayItems } from '@core/interfaces/display-items';
import { InspectionRequest } from '@core/interfaces/inspection-request';
import { IRConvertNotification, IRSendBackNotification, IRStatusUpdate } from '@core/interfaces/inspection-status-notification';
import { createReducer, on } from '@ngrx/store';
import { NotificationMessage } from 'src/app/osc-reference-app-common/notifications/notification-message';
import { InspectionRequestState } from '../inspection-request.state';
import { getItems } from '../store.helper';
import {
  InspectionRequestUpdateStatusAction,
  FetchIRPageAction,
  RevalidateFetchedIRPagesAction,
} from '../actions/inspection-request.action';

const initialMyItems: InspectionRequestState = {
  displayedIRsByFilter: null,
};
export const updateInspectionRequestStatus = (
  displayedIRsByFilter: DisplayItems<InspectionRequest>[],
  id: string,
  status: InspectionRequestItemStatus,
): DisplayItems<InspectionRequest>[] => {
  displayedIRsByFilter.forEach(inspectionRequestFilterOption => {
    inspectionRequestFilterOption.data.forEach(page => {
      const inspectionRequest = page.items.find(item => item.id === id);
      if (inspectionRequest) {
        inspectionRequest.status = status;
      }
    });
  });
  return displayedIRsByFilter;
};

export const updateInspectionRequestSendBackProgress = (
  displayedIRsByFilter: DisplayItems<InspectionRequest>[],
  id: string,
  notificationMsg: IRSendBackNotification,
): DisplayItems<InspectionRequest>[] => {
  displayedIRsByFilter.forEach(inspectionRequestFilterOption => {
    inspectionRequestFilterOption.data.forEach(page => {
      const inspectionRequest = page.items.find(item => item.id === id);
      if (inspectionRequest) {
        inspectionRequest.status = notificationMsg.inspectionRequestStatus;
        inspectionRequest.creationProgress = (inspectionRequest.eventSentForApprovalCount / inspectionRequest.eventCompletedCount) * 100;
        if (inspectionRequest.eventSentForApprovalCount === inspectionRequest.eventCompletedCount) {
          inspectionRequest.hasUpdate = false;
        }
      }
    });
  });
  return displayedIRsByFilter;
};

export const updateInspectionRequestCreationProgress = (
  displayedIRsByFilter: DisplayItems<InspectionRequest>[],
  id: string,
  notificationMsg: IRConvertNotification,
): DisplayItems<InspectionRequest>[] => {
  displayedIRsByFilter.forEach(inspectionRequestFilterOption => {
    inspectionRequestFilterOption.data.forEach(page => {
      const inspectionRequest = page.items.find(item => item.id === id);
      if (inspectionRequest) {
        inspectionRequest.status = notificationMsg.inspectionStatus;
        inspectionRequest.eventCount = notificationMsg.totalEventsCount;
        inspectionRequest.hubId = notificationMsg.hubId;
        inspectionRequest.eventsCreated = notificationMsg.convertedEventsCount;
        inspectionRequest.creationProgress = (notificationMsg.convertedEventsCount / notificationMsg.totalEventsCount) * 100;
      }
    });
  });
  return displayedIRsByFilter;
};

export const updateStatus = (displayedIRsByFilter: DisplayItems<InspectionRequest>[], status: NotificationMessage | IRStatusUpdate) => {
  if (!displayedIRsByFilter) {
    return;
  }

  if (status.title !== undefined) {
    const notificationMsg: IRConvertNotification | IRSendBackNotification = JSON.parse((status as NotificationMessage).message as string);

    if ((notificationMsg as IRConvertNotification).hubId) {
      return updateInspectionRequestCreationProgress(
        displayedIRsByFilter,
        notificationMsg.inspectionRequestId,
        notificationMsg as IRConvertNotification,
      );
    } else {
      return updateInspectionRequestSendBackProgress(
        displayedIRsByFilter,
        notificationMsg.inspectionRequestId,
        notificationMsg as IRSendBackNotification,
      );
    }
  } else {
    return updateInspectionRequestStatus(displayedIRsByFilter, status.id, (status as IRStatusUpdate).status);
  }
};

export const inspectionRequestsActionReducer = createReducer(
  initialMyItems,
  on(InspectionRequestUpdateStatusAction, (state, { status }) => ({
    ...state,
    displayedIRsByFilter: updateStatus(structuredClone(state.displayedIRsByFilter), status),
  })),
  on(FetchIRPageAction, (state, { input }) => ({
    ...state,
    displayedIRsByFilter: getItems(state.displayedIRsByFilter, input),
  })),
  on(RevalidateFetchedIRPagesAction, (state): { displayedIRsByFilter: any } => ({
    ...state,
    displayedIRsByFilter: null,
  })),
);
